import clsx from "clsx";
import CrossButton from "../CrossButton/CrossButton";
import './styles.scss';

export default function ModalPanel({ children, title, className, hideClose = false, withoutOffset = false, slot, onClose }) {
	return <div className={clsx('modal-panel', className, {
		'modal-panel--without-offset': withoutOffset,
	})}>
		<div className="modal-panel__top">
			{!hideClose && <CrossButton className="modal-panel__close" onClick={onClose} />}
			{title && <h2 className="modal-panel__title">{title}</h2>}
			{slot && <div className="modal-panel__slot">{slot}</div>}
		</div>
		<div className="modal-panel__bottom">
			<div className="modal-panel__bottom-inner">
				{children}
			</div>
		</div>
	</div>
}
